<template>
  <div>
    <b-modal id="modal_precios" size="lg" :title="titulo"
        hide-header ok-only content-class="shadow"
        button-size="sm" centered ok-title="Cancelar" ok-variant="outline-secondary">

        <div class="my-1">
          <b-card>
              <b-table striped hover sticky-header="300px" head-variant="light"
                :items="itemsPrecios" :fields="precios.fields"
                class="table-responsive-md bg-white" responsive="xs">

                <template slot="cell(hot)" slot-scope="{item: { hot,per }}">
                    <small>{{ hot }} <br> {{ per }}</small>
                </template>

                <!-- <template #cell(hot)="data">
                   <small> {{ data.hot }} <br> {{ data.per }} </small>
                </template>     -->

                <!-- <template #cell(action)="data">
                      <b-btn size="lg" variant="light" class="p-0" v-if="data.item.lib<=1">
                          <b-icon variant="danger" icon="x-square"></b-icon>
                      </b-btn>
                      <b-btn size="md" variant="success" class="p-1" v-else @click="selecciona(data)">
                          <b-icon icon="cart3"></b-icon>
                          <b-badge variant="success">{{data.item.lib}}</b-badge>
                      </b-btn>
                  </template> -->

              </b-table>
              <!-- {{ precios.items }}          -->
          </b-card>
      </div>

    </b-modal>
  </div>
</template>

<script>

export default {
  name: "modal_precios",

  data() {
    return {
        titulo: "Establecimientos - Precios - Solicitud",

        precios: {
            items: [],
            fields: [
                {key:'hot',label:'Establecimiento'},
                {key:'tph',label:'TipoHab'},
                {key:'reg',label:'Reg'},
                {key:'imp',label:'Importe'},
                {key:'sub',label:'Subven'},
                {key:'pag',label:'Pago'},
                {key:'action', label:''}
            ],
        },

    }
  },
  mounted() {
      //this.precios.items=this.$store.state.calculo;
      //this.precios.items=this.$store.state.calculo;
  },

  computed: {
      itemsPrecios() {
          return this.$store.state.calculo;
      }
  },
  methods: {
      close() { alert('cerrar');
          this.hideModal();
      },

      selecciona() {

      },
  }
}
</script>
